module.exports = __webpack_public_path__ + "img/org3.fbb9102d.png";